export default {
  relatorios: [],
  relatorio_oportunidades: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
